<template>
    <app-data-table
        :fields="fields"
        v-bind="context"
        :on-change-page="page => $emit('change-page', page)"
    >
        <template v-slot:photo="{ item }">
            <b-img :src="item.photo" height="45px"></b-img>
        </template>

        <template slot="birth_date" slot-scope="data">
            {{ data.item.birth_date | date }}
        </template>

        <template slot="actions" slot-scope="data">
            <b-button
                size="sm"
                variant="success"
                @click="$emit('activate-person', data.item)"
                >Activar Usuario</b-button
            >
            <b-button
                size="sm"
                variant="danger"
                @click="$emit('reject-person', data.item)"
                >Rechazar Usuario</b-button
            >
        </template>
    </app-data-table>
    <!-- <b-table
        :bordered="true"
        :small="true"
        :fields="fields"
        :items="items"
        thead-class="thead-orange"
        responsive
    >
        <template slot="photo" slot-scope="data">
            <img
                :src="data.item.photo"
                alt=""
                class="rounded"
                height="45"
                width="60"
                v-if="!!data.item.photo"
            />
        </template>
        <template slot="birth_date" slot-scope="data">
            {{ data.item.birth_date | date }}
        </template>

        <template slot="actions" slot-scope="data">
            <b-button
                size="sm"
                variant="success"
                @click="onActivatePerson(data.item)"
                >Activar Usuario</b-button
            >
            <b-button
                size="sm"
                variant="danger"
                @click="onRejectPerson(data.item)"
                >Rechazar Usuario</b-button
            >
        </template>
    </b-table> -->
</template>
<script>
import fields from './fields'
export default {
    props: {
        context: {
            type: Object,
            required: true,
        },
    },
    data() {
        return {
            fields: fields,
        }
    },
}
</script>
